import { render, staticRenderFns } from "./detailDrawer.vue?vue&type=template&id=216702db&scoped=true"
import script from "./detailDrawer.vue?vue&type=script&lang=js"
export * from "./detailDrawer.vue?vue&type=script&lang=js"
import style0 from "./detailDrawer.vue?vue&type=style&index=0&id=216702db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216702db",
  null
  
)

export default component.exports